import * as R from 'ramda';
import {
  countries,
  MASK_OF_ZIP_CODE_DEFAULT,
} from '@/utils/constants';

const getZipCodeMask = (country) => R.pathOr(MASK_OF_ZIP_CODE_DEFAULT, [country, 'zipCodeMask'], countries);

export default getZipCodeMask;
